import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import BalanceSheetContainer from 'Components/UI/Snapshot/BalanceSheetContainer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { MissionControlBalanceSheetTab } from './missionControlBalanceSheetTab';

const styles = () => ({
  container: {}, // Not used -- just to get around a console error
  root: {
    flexWrap: 'wrap',
  },
});

const View = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();

  const defaultComponentAndProps = {
    Component: BalanceSheetContainer,
    props: { elevation: 0 },
  };
  const { Component, props } = pick(householdResource, {
    [fr.relationships.householdBalanceSheetPage.name]: {
      Component: MissionControlBalanceSheetTab,
      props: { relationship: householdResource.relationship(fr.relationships.householdBalanceSheetPage.name) },
    },
  }, defaultComponentAndProps);

  return <Component {...props} className={classNames(classes.root, className)} />;
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
